import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import ConditionalRender from '../../components/ConditionalRender';
import EventList from '../../components/EventList';
import LoginAlert from '../../components/LoginAlert';
import NoEvents from '../../components/NoEvents';
import { CANCELLED, EVENTS } from '../../enums';
import { CSSEvent, Store } from '../../types/model';

type PropsType = {
  events: CSSEvent[];
  selectedStore: Store;
  numberOfActiveFilters: number;
};

const EventsTitle = styled.h2`
  margin-bottom: var(--space-150);
`;

const StoreSelected = ({
  events,
  selectedStore,
  numberOfActiveFilters,
}: PropsType) => {
  const { t } = useTranslation();
  const activeEvents = events.filter((e) => e.visibilityState !== CANCELLED);

  const hasEvents = activeEvents.length > 0;

  return (
    <ConditionalRender predicate={hasEvents} fallback={<NoEvents />}>
      <ConditionalRender predicate={numberOfActiveFilters === 0}>
        <EventsTitle>{t('event.pageTitle')}</EventsTitle>
      </ConditionalRender>
      <LoginAlert margin="0 0 var(--space-200) 0" initiator={EVENTS} />
      <EventList
        events={activeEvents}
        listLabel={t('event.eventListLabel', {
          storeName: selectedStore?.storeName,
        })}
      />
    </ConditionalRender>
  );
};

export default StoreSelected;
